

export default {
    //namespaced: true,
    state: {
        // 页签数据列表
        visitedViews: [],
    },
    getters: {
    },
    mutations: {
        // 获取页签数据
        getVisitedView(state) {
            let visitedViews = JSON.parse(sessionStorage.getItem('visitedViews'))
            if (!visitedViews) {
                visitedViews = [
                    {
                        path: '/index',
                        name: 'Index',
                        meta: {
                            title: '首页',
                            icon: 'home',
                        },
                    },
                ]
            }
            state.visitedViews = visitedViews
        },
        // 添加页签
        addVisitedView(state, data) {
            state.visitedViews.push(data)
            sessionStorage.setItem('visitedViews', JSON.stringify(state.visitedViews))

        },
        // 删除页签
        delVisitedView(state, index) {
            state.visitedViews.splice(index, 1)
            sessionStorage.setItem('visitedViews', JSON.stringify(state.visitedViews))
        },

        delAllVisitedView(state) {      // 清除全部
            let baseView = state.visitedViews[0]        // 默认tag(首页)，不可清除
            state.visitedViews.length = 0
            state.visitedViews.push(baseView)
            sessionStorage.setItem('visitedViews', JSON.stringify(state.visitedViews))
        },

        delLeftVisitedView(state, index) {     // 关闭左侧
            state.visitedViews.splice(1, index - 1); // 索引0的首页不删除，从索引1开始删除
            sessionStorage.setItem('visitedViews', JSON.stringify(state.visitedViews))
        },

        delRightVisitedView(state, index) {    // 关闭右侧
            state.visitedViews.length = index + 1
            sessionStorage.setItem('visitedViews', JSON.stringify(state.visitedViews))
        },

        delOtherVisitedView(state, index) {    // 关闭其他
            let baseView = state.visitedViews[0]        // 默认tag(首页)，不可清除
            let operateView = state.visitedViews[index] // 当前操作的tag

            state.visitedViews.length = 0
            state.visitedViews.push(baseView)

            if (index != 0) {
                // 只有当前操作的不是第一项的首页，才需要重新push回数组里
                state.visitedViews.push(operateView)
            }
            sessionStorage.setItem('visitedViews', JSON.stringify(state.visitedViews))
        },

    },
    actions: {
    }
}
